export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70d0c330731c53e47ab6ec40cc69dba45dce1f40a0&name=pushAdClickData!'